import { z } from 'zod';

export const couponCodeSchema = z.object({
  code: z
    .string()
    .min(2, 'Coupon code must be at least 2 characters')
    .max(50, 'Coupon code must not exceed 50 characters')
    .toUpperCase(),
});

export type CouponCodeFormData = z.infer<typeof couponCodeSchema>;
